var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 0.199994C7.15358 0.199994 7.30718 0.258794 7.42418 0.375794L13.4242 6.37579C13.5958 6.54739 13.6474 6.80539 13.5544 7.02979C13.462 7.25419 13.2424 7.39999 13 7.39999L0.999984 7.39999C0.757584 7.39999 0.537984 7.25419 0.445584 7.02979C0.352584 6.80539 0.404183 6.54739 0.575784 6.37579L6.57578 0.375794C6.69278 0.258794 6.84638 0.199994 6.99998 0.199994Z",
    fill: "#4AA23C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDrop);
export default __webpack_public_path__ + "static/media/active_drop.c1f08e9101edfc478a750e363f0e89a9.svg";
export { ForwardRef as ReactComponent };